<template>
  <div class="asset-orderType-assign-tool">
    <base-select
      v-model="orderTypeCodeId"
      :service="$options.codeService"
      fetch-func="all"
      :fetch-params="{
        type: 'orderType',
        contract_id: contractId,
        firm_id: contractId ? undefined : $store.state.Auth.user.firmId,
      }"
      :fetch-on-init="false"
      default-option-label="Select Order Type"
      message="Order Type will be assigned/unassigned to the filtered assets."
      :disabled="!contractId"
      ref="selectOrderType"
    ></base-select>
    <div class="columns">
      <div class="column is-6">
        <b-button
          expanded
          :disabled="!orderTypeCodeId || unassigning"
          :loading="assigning"
          @click="assign"
        >
          ASSIGN
        </b-button>
      </div>
      <div class="column is-6">
        <b-button
          type="is-danger"
          expanded
          :disabled="!orderTypeCodeId || assigning"
          :loading="unassigning"
          @click="unassign"
        >
          UNASSIGN
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { AssetService } from "@/services/asset.service";
import { CodeService } from "@/services/code.service";

export default {
  codeService: CodeService,
  props: {
    contractId: {
      type: [String, Number],
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    BaseSelect,
  },
  data: () => ({
    orderTypeCodeId: "",
    assigning: false,
    unassigning: false,
  }),
  watch: {
    contractId() {
      this.orderTypeCodeId = "";
      this.$nextTick(() => {
        this.$refs.selectOrderType.fetchOptions();
      });
    },
  },
  methods: {
    async assign() {
      try {
        this.assigning = true;
        await AssetService.assignOrderTypeCode(
          {
            // contract_id: this.contractId,
            // orderType_code_id: this.orderTypeCodeId,
            orderType_code_ids: [this.orderTypeCodeId],
          },
          {
            ...this.filters,
            outerRad: undefined,
            limit: undefined,
          }
        );
        this.$buefy.toast.open({
          message: "Order type has been assigned.",
          type: "is-info",
          position: "is-top-right",
        });
        this.$emit("assign");
      } catch (err) {
      } finally {
        this.assigning = false;
      }
    },
    async unassign() {
      try {
        this.unassigning = true;
        await AssetService.unassignOrderTypeCode(
          {
            // contract_id: this.contractId,
            // orderType_code_id: this.orderTypeCodeId,
            orderType_code_ids: [this.orderTypeCodeId],
          },
          {
            ...this.filters,
            outerRad: undefined,
            limit: undefined,
          }
        );
        this.$buefy.toast.open({
          message: "Order type has been unassigned.",
          type: "is-info",
          position: "is-top-right",
        });
        this.$emit("unassign");
      } catch (err) {
      } finally {
        this.unassigning = false;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Asset/AssetOrderTypeCodeAssignTool.vue